// theme specific styles can be found in VMenu.styles.ts
export default {
  root: {
    class: ['tw-min-w-[12rem]']
  },
  menu: {
    class: ['tw-list-none', 'tw-m-0', 'tw-py-1', 'tw-outline-none']
  },
  menuitem: {
    class: ['tw-relative', 'tw-px-2', 'tw-py-1']
  },
  content: {
    class: ['tw-rounded', 'tw-transition-shadow', 'tw-duration-200']
  },
  action: {
    class: [
      'tw-flex',
      'tw-items-center',
      'tw-p-2',
      'tw-no-underline',
      'tw-overflow-hidden',
      'tw-cursor-pointer',
      'tw-select-none',
      "after:tw-content-['']",
      'after:tw-absolute',
      'after:tw-inset-0'
    ]
  },
  label: {
    class: ['tw-text-sm']
  },
  submenuheader: {
    class: ['tw-font-bold', 'tw-m-0', 'tw-py-3', 'tw-px-5', 'tw-rounded-tl-none', 'tw-rounded-tr-none']
  },
  transition: {
    enterFromClass: 'tw-opacity-0 tw-scale-y-[0.8]',
    enterActiveClass: 'tw-transition-[transform,opacity] tw-duration-[120ms] tw-ease-[cubic-bezier(0,0,0.2,1)]',
    leaveActiveClass: 'tw-transition-opacity tw-duration-100 tw-ease-linear',
    leaveToClass: 'tw-opacity-0'
  }
};
